const ctrlCode = ['control', 'meta']
const keyContain = ({key}) => key && ctrlCode.indexOf(
  key.toLowerCase()
) != -1
export const useKeyPress = {
  data(){
    return {
      isCtrl: false
    }
  },
  methods: {
    keydown(data){
      if(keyContain(data))
        this.isCtrl = true
    },
    keyup(data){
      if(keyContain(data))
        this.isCtrl = false
    }
  },
  mounted(){
    window.addEventListener('keydown', this.keydown)
    window.addEventListener('keyup', this.keyup)
  },
  beforeUnmount(){
    window.removeEventListener('keydown', this.keydown)
    window.removeEventListener('keyup', this.keyup)
    this.isCtrl = false
  }
}


// WEBPACK FOOTER //
// ./src/views/layout/Sidebar/Menu/keyPress.js